module.exports = __webpack_public_path__ + "media/images/hiking-e855535560e8ef5e0b0ba6503822aa19.svg";